import { createContext, useContext } from "react";
import en from "./i18n/en.json";
import fr from "./i18n/fr.json";

/** The interface follows the person's language (EN, FR), set on the profile (docs/37 §1). */
export type Lang = "en" | "fr";
const DICTS: Record<Lang, Record<string, string>> = { en, fr };

export function translate(lang: Lang, key: string, vars: Record<string, string | number> = {}): string {
  const text = DICTS[lang][key] ?? DICTS.en[key] ?? key;
  return text.replace(/\{(\w+)\}/g, (_, k: string) => String(vars[k] ?? ""));
}

export const LangContext = createContext<Lang>("en");
export function useT() {
  const lang = useContext(LangContext);
  return (key: string, vars?: Record<string, string | number>) => translate(lang, key, vars);
}
export const useLang = () => useContext(LangContext);
